<template>
  <div class="banner-item">
    <div class="banner-item__image-wrapper">
      <img class="banner-item__image" :src="getImage(page.image)" alt="" />
    </div>

    <div class="banner-item__text">
      <h1 class="banner-item__title" v-html="page.title"></h1>
      <p
        v-if="page.subtitle"
        class="banner-item__subtitle"
        v-html="page.subtitle"
      ></p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { getImage } from '@/models/onboarding'
import type { OnboardingIntroPage } from '@/models/onboarding.types'

interface Props {
  page: OnboardingIntroPage
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.banner-item {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 520px;
  margin: 0;
  scroll-snap-align: center;
  flex-direction: column;

  @media only screen and (max-width: $w-tablet-s) {
    width: 100%;
    gap: 24px;
    @media only screen and (max-height: 714px) {
      gap: 12px;
    }
  }

  &__text {
    @media only screen and (max-width: $w-tablet-s) {
      flex: 1;
    }
  }

  &__title {
    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.02em;
    text-align: center;
    color: $c-black-2;
    margin-top: 108px;
    max-width: 335px;
    margin-inline: auto;

    @media only screen and (max-width: $w-tablet-s) {
      margin: 0;
      font-size: 32px;
      line-height: 36px;

      @media only screen and (max-height: 714px) {
        font-size: min(24px, 3.75svh);
        line-height: 1.12;
      }
    }
  }

  &__subtitle {
    font-family: Rotunda;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.02em;
    text-align: center;
    color: $c-black-6;
    margin-top: 24px;

    @media only screen and (max-width: $w-tablet-s) {
      margin-top: 12px;
      @media only screen and (max-height: 714px) {
        margin-top: 4px;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  &__image {
    height: 270px;
    @media only screen and (max-width: $w-tablet-s) {
      height: 220px;
      max-height: 100%;
      @media only screen and (max-height: 714px) {
        height: 150px;
      }
    }

    &-wrapper {
      display: flex;
      justify-content: center;
      @media only screen and (max-width: $w-tablet-s) {
        min-height: 0;
        max-height: 100%;
      }
    }
  }
}
</style>
